import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2012',
    ecrans: ['00-2']
});
